import { render, staticRenderFns } from "./ColorsTabs.vue?vue&type=template&id=b78e9168&scoped=true&"
import script from "./ColorsTabs.vue?vue&type=script&lang=ts&"
export * from "./ColorsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ColorsTabs.vue?vue&type=style&index=0&id=b78e9168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e9168",
  null
  
)

export default component.exports